import React, { useEffect, useState } from "react";
import { removeTrailingSlash } from "../utils/urls";
interface LinkNameProps {
  path: string;
}

const LinkName: React.FC<LinkNameProps> = ({ path }) => {
  const [name, setName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const endpoint = removeTrailingSlash(path);
      const response = await fetch(`/query/page${endpoint}/page.json`);
      if (!response.ok) {
        setName("Unknown");
        throw new Error("Failed to fetch data");
      }
      const result = await response.json();
      setName(result.title);
    };
    fetchData();
  }, [path]);
  return <>{name}</>;
};

export default LinkName;
